import React from 'react';
import './SearchInput.css';

const SearchInput = ({ value, onChange, placeholder = "Search...", width = "250px", inputType = "text" }) => {
  return (
    <input
      type={inputType??"text"}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="common-search-input"
      style={{ width }}
    />
  );
};

export default SearchInput;